import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

homePageStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        /* max-width: 1440px !important; */
        max-width: 100% !important;
        div[class^="GridWrapper"] {
            margin: 0px auto;
        }
        div[class^="GridOffset"] {
            max-width: 100% !important;
            margin: 0 auto;
        }
        > div[class^="Wrapper"] {
            > div[class^="GridWrapper"] {
                padding: 0px;
                > div[class^="GridOffset"] {
                    max-width: 100%;
                    > div[class^="GridItemStyle-sc"] {
                        padding: 0px;
                        > div[class^="Wrapper"] {
                            > div[class^="GridWrapper"] {
                                padding: 0px;
                                margin: 0px auto;
                            }
                        }
                    }
                }
            }
        }
    `,
};
